import React, { useState } from "react";

import {FormularioBusqueda} from './FormularioBusqueda';
import { TablaResultados } from './TablaResultados';

import servicioHttp from "../../../servicio/ServicioHttp";
import servicioObjetos from "../../../servicio/ServicioObjetos";

export const TxtCasaLey = () => {

    const [paginacion,setPaginacion] =useState({
        registrosTotales:0,
    });
    const [paginacionRestriccion, setPaginacionRestriccion] = useState([]);
    const [inicio,setInicio]=useState(0);

    const onFormularioOk = (paginacionRequest) => {
        setInicio(0);
        setPaginacionRestriccion(paginacionRequest);
        ejecutarHttpBusqueda(paginacionRequest);
    }

    const ejecutarHttpBusqueda = (paginacionRequest) => {
        servicioHttp.consumirPostHttp("lote/paginar.json", paginacionRequest).then(response => {
            let { objeto } = response.data;
            setPaginacion(objeto);
        }).catch(error => {

        });
    }

    const cambiaPagina = (event) => {
        if (!servicioObjetos.esObjetoVacio(paginacionRestriccion)) {
            paginacionRestriccion.numeroPagina = event.page;
            paginacionRestriccion.registrosPorPagina = event.rows;
            setInicio(event.first);
            ejecutarHttpBusqueda(paginacionRestriccion);
        }
    }

    const funcionBusquedaAlEliminar = () =>{
        ejecutarHttpBusqueda(paginacionRestriccion);
    }

    return (<div >
        <FormularioBusqueda onFormularioOk={onFormularioOk}/>
        <TablaResultados paginacion={paginacion}
        inicio={inicio} cambiaPagina={cambiaPagina} funcionBusqueda={funcionBusquedaAlEliminar}/>
    </div>);
}